import { Notify } from "../../utils/notificationManager";
import { history } from "../../containers/Root";

export const FETCH_CUSTOMER_REGISTRATIONS = "FETCH_CUSTOMER_REGISTRATIONS";
export const CLEAR_CUSTOMER_REGISTRATIONS = "CLEAR_CUSTOMER_REGISTRATIONS";
export const UPDATE_CUSTOMER_REGISTRATIONS = "UPDATE_CUSTOMER_REGISTRATIONS";
export const UPDATE_CUSTOMER_REGISTRATION_LIST_FILTER = "UPDATE_CUSTOMER_REGISTRATION_LIST_FILTER";
export const CLEAR_CUSTOMER_REGISTRATION_LIST_FILTER = "CLEAR_CUSTOMER_REGISTRATION_LIST_FILTER";

export const FETCH_CUSTOMER_REGISTRATION_DETAILS = "FETCH_CUSTOMER_REGISTRATION_DETAILS";
export const UPDATE_CUSTOMER_REGISTRATION_DETAILS = "UPDATE_CUSTOMER_REGISTRATION_DETAILS";
export const CLEAR_CUSTOMER_REGISTRATION_DETAILS = "CLEAR_CUSTOMER_REGISTRATION_DETAILS";

export const FETCH_CUSTOMER_REGISTRATION = "FETCH_CUSTOMER_REGISTRATION";
export const UPDATE_CUSTOMER_REGISTRATION = "UPDATE_CUSTOMER_REGISTRATION";
export const CLEAR_ACTIVE_CUSTOMER = "CLEAR_ACTIVE_CUSTOMER";

export const FETCH_CREATE_CUSTOMER = "FETCH_CREATE_CUSTOMER";
export const UPDATE_CREATE_CUSTOMER = "UPDATE_CREATE_CUSTOMER";

export const UPDATE_ERROR_CREATE_CUSTOMER = "UPDATE_ERROR_CREATE_CUSTOMER";

export function fetchCustomerRegistrations() {
  return {
    type: FETCH_CUSTOMER_REGISTRATIONS,
    meta: {
      endpoint: "/api/registrations",
      success: updateCustomerRegistrations,
    },
  };
}

export function fetchCustomerRegistration(nmi) {
  return {
    type: FETCH_CUSTOMER_REGISTRATION,
    meta: {
      endpoint: `/fleet/registration/customers/${nmi}/edit`,
      success: updateCustomerRegistration,
    },
  };
}

export function updateCustomerRegistration(customer) {
  return {
    type: UPDATE_CUSTOMER_REGISTRATION,
    payload: customer.data,
  };
}

export function clearCustomerRegistrations() {
  return {
    type: CLEAR_CUSTOMER_REGISTRATIONS,
  };
}

export function clearActiveCustomer() {
  return {
    type: CLEAR_ACTIVE_CUSTOMER,
  };
}

export function updateCustomerRegistrations(customers) {
  return {
    type: UPDATE_CUSTOMER_REGISTRATIONS,
    payload: customers.data,
  };
}

export function fetchCustomerRegistrationDetails(id) {
  return {
    type: FETCH_CUSTOMER_REGISTRATION_DETAILS,
    meta: {
      endpoint: `/api/registrations/${id}`,
      success: updateCustomerRegistrationDetails,
      errorMessage: "Unable to fetch customer registration details.",
    },
  };
}

export function updateCustomerRegistrationDetails(customerResp) {
  return {
    type: UPDATE_CUSTOMER_REGISTRATION_DETAILS,
    payload: {
      customerRegistrationDetails: customerResp.data,
    },
  };
}

export function updateCustomerRegistrationListFilter(filterKey, filterValue) {
  return {
    type: UPDATE_CUSTOMER_REGISTRATION_LIST_FILTER,
    payload: {
      filterKey: filterKey,
      filterValue: filterValue,
    },
  };
}

export function clearCustomerRegistrationListFilter() {
  return {
    type: CLEAR_CUSTOMER_REGISTRATION_LIST_FILTER,
  };
}

export function clearCustomerRegistrationDetails() {
  return {
    type: CLEAR_CUSTOMER_REGISTRATION_DETAILS,
  };
}

export function createCustomer(customer) {
  return {
    type: FETCH_CREATE_CUSTOMER,
    meta: {
      endpoint: "/api/registrations",
      method: "POST",
      body: {
        name: customer.name,
        nmi: customer.nmi,
        phone: customer.phone,
        email: customer.email,
        addressLine1: customer.addressLine1,
        city: customer.city,
        state: customer.state.value,
        postcode: customer.postcode,
      },
      success: updateCreateCustomer,
      error: createCustomerFailure,
    },
  };
}

function updateCreateCustomer(response) {
  if (response.status === "OK") {
    history.push("/ordering/customers/new");
    Notify.success("Customer Registered", `Successfully registered ${response.data.name}`);
  }
  if (response.status === "ERROR") {
    return {
      type: UPDATE_ERROR_CREATE_CUSTOMER,
      payload: {
        customer: null,
        error: response.error,
      },
    };
  }
  return {
    type: UPDATE_CREATE_CUSTOMER,
    payload: {
      customer: response.data,
      error: response.error,
    },
  };
}

function createCustomerFailure(payload, response) {
  return {
    type: UPDATE_ERROR_CREATE_CUSTOMER,
    payload: {
      customer: null,
      error: "An unexpected error occurred",
    },
  };
}
